CTAMap.place = {
  obj: null,
  lat: null,
  lng: null,
};

CTAMap.place.getRadius = function () {
  // r = radius of the earth in km
  var r = 6371.0;

  var viewportUndefined =
    CTAMap.place.obj === null ||
    typeof CTAMap.place.obj.geometry.viewport.f === 'undefined' ||
    typeof CTAMap.place.obj.geometry.viewport.b === 'undefined';

  if (!CTAMap.place.obj || viewportUndefined) {
    return 100;
  }

  // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
  var lat1 = CTAMap.place.obj.geometry.viewport.f.b / 57.2958;
  var lon1 = CTAMap.place.obj.geometry.viewport.b.b / 57.2958;
  var lat2 = CTAMap.place.obj.geometry.viewport.f.f / 57.2958;
  var lon2 = CTAMap.place.obj.geometry.viewport.b.f / 57.2958;

  // distance = circle radius from center to Northeast corner of bounds
  var dis =
    r *
    Math.acos(
      Math.sin(lat1) * Math.sin(lat2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)
    );

  return dis;
};

CTAMap.place.getCoutryCode = function () {
  var addressComponents = CTAMap.place.obj.address_components;
  for (var i = addressComponents.length - 1; i >= 0; i--) {
    if (addressComponents[i].types[0] === 'country') {
      return addressComponents[i].short_name;
    }
  }
};

CTAMap.place.getDetails = function (callback) {
  if (
    !GLSearch.selected.placeId &&
    GLSearch.selected.coordinates.lat &&
    GLSearch.selected.coordinates.lng
  ) {
    CTAMap.place.lat = parseFloat(GLSearch.selected.coordinates.lat);
    CTAMap.place.lng = parseFloat(GLSearch.selected.coordinates.lng);
    callback({ coordinates: { lat: CTAMap.place.lat, lng: CTAMap.place.lng } });
    return;
  }
  var placesService = new google.maps.places.PlacesService(CTAMap.map.obj);
  var placeId = GLSearch.selected.placeId;
  placesService.getDetails({ placeId: placeId }, function (result, status) {
    if (status !== google.maps.places.PlacesServiceStatus.OK) {
      console.error(status);
      //reject(status);
      return;
    }
    CTAMap.place.obj = result;
    callback({ place: result });
  });
  return;
};
